import {FC, useState} from 'react';
import './ProposalsOperations.scss';
import SkeletonTable from '../../../components/SkeletonTable/SkeletonTable';
import AppPagination from '../../../components/AppPagination/AppPagination';
import moment from 'moment';
import {usePaginate} from '../../../providers/PaginateProvider';
import PainelMasterPage from '../../../components/PainelMasterPage/PainelMasterPage';
import PageBase from '../../../components/PageBase/PageBase';
import {ProposalPromoter} from "../../../models/ProposalCovenant/ProposalsCovenantsTableModel";
import Swal from "sweetalert2";
import {toast} from "react-toastify";
import ButtonEdit from "../../../components/ButtonEdit/ButtonEdit";
import ButtonDelete from "../../../components/ButtonDelete/ButtonDelete";
import ModalProposalOperationsEdit
    from "../../../components/ProposalsTrack/Covenant/ModalProposalOperationsEdit/ModalProposalOperationsEdit";
import {OperationModel} from "../../../models/Operation";
import {useOperations} from "../../../providers/Operations/OperationsProvider";

interface ProposalsOperationsProps {
}

const ProposalsOperations: FC<ProposalsOperationsProps> = () => {
    const [showModalFilter, setShowModalFilter] = useState<boolean>(false);
    const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
    const [itemEdit, setItemEdit] = useState<OperationModel | null>(null);

    const {
        params,
        setParams,
        proposalsOperations,
        isLoading,
        handleList,
        handleInative
    } = useOperations();
    const {pagesPaginate, handlePaginate} = usePaginate();


    const handleInativeAlert = (item: OperationModel) => {
        Swal.fire({
            title: "Atenção!",
            html: `Deseja realmente inativar a operação ${item.name}`,
            icon: "warning",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            showConfirmButton: true,
            showCancelButton: true,
        }).then((value) => {
            if (value.isConfirmed) {
                deleteItem(item)
            }

        })
    }

    const deleteItem = async (item: ProposalPromoter) => {
        const res = await handleInative(item?.id ?? null);
        if (!res) {
            handleList();
            toast.success(`${item.name} inativada com sucesso!`)
            return;
        }

        toast.error(res)

    }

    const renderList = () => {
        if (proposalsOperations?.length > 0) {
            return (
                <>
                    {proposalsOperations?.map((x: OperationModel) => (
                        <tr key={x.id}>
                            <td className="text-sm text-center">{x.id}</td>
                            <td className="text-sm text-wrap" style={{width: '20%'}}>{x.name}</td>
                            <td className="text-sm text-wrap">{x.acronym ?? x.sigla}</td>
                            <td className="text-center text-sm">
                <span className={`badge ${!!x.deleted_at ? 'badge-danger' : 'badge-success'}`}>
                  {!!x.deleted_at ? 'Inativa' : 'Ativa'}
                </span>
                            </td>
                            <td className="text-center text-sm">{moment(x.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                            <td className='text-center text-sm'>
                <span className='d-flex gap-2'>
                                <ButtonEdit
                                    tooltipText="Editar"
                                    onClick={() => {
                                        setItemEdit(x);
                                        setShowModalInsert(true);
                                    }}
                                />
                                <ButtonDelete
                                    onClick={() => handleInativeAlert(x)}
                                    tooltipText="Inativar"/>
                                 </span>
                            </td>
                        </tr>
                    ))}
                </>
            );
        } else {
            return (<tr className='text-sm text-center'>
                <td colSpan={6}>Não há registros</td>
            </tr>);
        }
    }

    const renderContent = () => {
        return (
            <div className="table-responsive p-0">
                {isLoading ? (
                    <SkeletonTable columns={6}/>
                ) : (
                    <table className="table table-flush">
                        <thead className="thead-light">
                        <tr>
                            <th className="text-center" scope="col">#ID</th>
                            <th scope="col">NOME</th>
                            <th scope="col">SIGLA</th>
                            <th scope="col" className="text-center">STATUS</th>
                            <th scope="col" className="text-center">DATA DE CADASTRO</th>
                            <th className="text-center" scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {renderList()}
                        </tbody>
                    </table>
                )}

                {(pagesPaginate) && (
                    <div>
                        <nav aria-label="...">
                            <AppPagination
                                pages={pagesPaginate}
                                handlePaginate={handlePaginate}
                                params={params}
                                setParams={setParams}
                            />
                        </nav>
                    </div>
                )}
            </div>
        )
    }

    return (
        <PainelMasterPage
            title='Operações'
            icon='fas fa-comments-dollar'
        >
            <div className="ProposalsOperations" data-testid="ProposalsOperations">
                <PageBase
                    content={renderContent()}
                    title={'Operações'}
                    subtitle={'Listagem de operações'}
                    hasFilter={false}
                    textButtonAdd='+ Nova Operação'
                    handleAdd={() => setShowModalInsert(true)}
                    handleFilter={() => setShowModalFilter(true)}
                />
            </div>

            <ModalProposalOperationsEdit

                item={itemEdit}
                show={showModalInsert}
                onClose={() => {
                    setShowModalInsert(false);
                    setItemEdit(null);

                }}
            />
        </PainelMasterPage>
    );
}

export default ProposalsOperations;
